import { Component, OnInit } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';

@Component({
  selector: 'app-termsandconditions',
  templateUrl: './termsandconditions.component.html',
  styleUrls: ['./termsandconditions.component.css']
})
export class TermsandconditionsComponent implements OnInit {
  title: string;

  constructor(public bsModalRef: BsModalRef) { }

  ngOnInit() {
    this.title = " Terms and Conditions";
  }

}
